/**
 * The square icon tile for a source type: the vendor logo on a neutral tile
 * (ADR-0010), or a colour-tinted semantic icon when no logo is available.
 */

import { ThemeIcon } from "@mantine/core";
import { sourceVisual } from "./sourceVisuals";

export function SourceTile({ sourceType, size = 44 }: { sourceType: string; size?: number }) {
  const visual = sourceVisual(sourceType);
  const glyphSize = Math.round(size * 0.58);

  if (visual.logo) {
    return (
      <ThemeIcon size={size} radius="md" variant="default">
        <img
          src={visual.logo}
          alt=""
          width={glyphSize}
          height={glyphSize}
          style={{ objectFit: "contain" }}
        />
      </ThemeIcon>
    );
  }

  const { Icon, color } = visual;
  return (
    <ThemeIcon size={size} radius="md" variant="light" color={color}>
      <Icon size={glyphSize} />
    </ThemeIcon>
  );
}
